import { Navigate } from "react-router-dom";
import auth from "../../utils/auth";

const PrivateRoute = ({ children }) => {
  let isAuth = auth.getToken();
  return isAuth !== null ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
